import { atom } from "jotai"

export const isMobileAtom = atom(true)
